import { ProgramThumbnailGroup } from '@type/buzzkuri/program-detail'
import { RecommendTrainingProgramListItem } from './Item'

type Props = {
  recommendPrograms: ProgramThumbnailGroup
}

export const RecommendTrainingProgramList = ({
  recommendPrograms,
}: Props): JSX.Element => (
  <div>
    {recommendPrograms.map((program, i) => (
      <div
        key={i}
        className="pt-[5.3vw] first:pt-0 lg:pt-[1.6vw] mt-[5.3vw] lg:mt-[1.6vw] lg:w-[21.9vw] first:border-0 border-t border-[#F7F7F7]"
      >
        <RecommendTrainingProgramListItem {...program} />
      </div>
    ))}
  </div>
)
